<section
  class="grid w-full max-w-full grid-cols-2 gap-2 md:w-fit md:grid-cols-[repeat(2,15rem)] lg2:grid-cols-[repeat(2,18rem)] lg2:gap-4 xl:grid-cols-[repeat(2,20rem)] xl2:grid-cols-[repeat(2,24rem)]"
  aria-labelledby="ticket-count-summary-heading"
  [attr.aria-busy]="isLoading"
>
  <h3 id="ticket-count-summary-heading" class="sr-only">
    Ticket count summary
  </h3>
  <div
    class="flex min-w-0 flex-col rounded-xl bg-black/10 px-3 py-3 shadow-inner lg2:px-5 xl:px-10 xl:py-5"
    role="group"
    [attr.aria-label]="
      getTypeSummaryLabel(
        'Proactive',
        ticketTypeCount()?.proactive || 0,
        proactiveAverageTimeToFirstTouch(),
        proactiveAverageTimeToRepair()
      )
    "
  >
    <div
      class="flex min-w-0 items-center justify-center lg2:min-w-[190px] xl:min-w-[210px]"
    >
      <div
        class="text-[2.75rem] font-normal leading-[3.25rem] text-white md:text-[3.25rem] md:leading-[4rem] lg2:text-[4rem] lg2:leading-[4.75rem] xl:text-[5rem] xl:leading-[6rem]"
        aria-hidden="true"
      >
        @if (isLoading) {
          <div
            class="h-12 w-16 animate-pulse rounded bg-white/20 lg2:h-16 lg2:w-20 xl:h-20 xl:w-24"
            role="status"
            aria-label="Loading proactive ticket count"
          ></div>
        } @else {
          {{ ticketTypeCount()?.proactive || 0 }}
        }
      </div>
      <div
        class="min-w-0 pl-2 pt-1 text-[10px] font-bold uppercase leading-3 text-white/60 lg2:pl-3 lg2:pt-2 lg2:text-sm lg2:leading-5 xl:pl-4 xl:text-base xl:leading-6"
      >
        Proactive
        <span
          class="flex whitespace-nowrap text-xl font-normal normal-case leading-7 text-white/80 md:text-2xl md:leading-8 lg2:text-[32px] lg2:leading-[40px] xl:text-[40px] xl:leading-[48px]"
          aria-hidden="true"
          >Ticket{{ ticketTypeCount()?.proactive === 1 ? '' : 's' }}</span
        >
      </div>
    </div>
    <div
      class="mt-1 hidden space-y-0.5 text-center font-lato md:block md:text-[11px] lg2:text-xs xl:text-sm"
    >
      <div class="text-white/60">
        Avg. Pickup Time:
        <span class="font-bold text-white/90">{{
          proactiveAverageTimeToFirstTouch()
        }}</span>
      </div>
      <div class="text-white/60">
        Avg. Repair Time:
        <span class="font-bold text-white/90">{{
          proactiveAverageTimeToRepair()
        }}</span>
      </div>
    </div>
  </div>
  <div
    class="flex min-w-0 flex-col rounded-xl bg-black/10 px-3 py-3 shadow-inner lg2:px-5 xl:px-10 xl:py-5"
    role="group"
    [attr.aria-label]="
      getTypeSummaryLabel(
        'Non-Proactive',
        ticketTypeCount()?.nonProactive || 0,
        nonProactiveAverageTimeToFirstTouch(),
        nonProactiveAverageTimeToRepair()
      )
    "
  >
    <div
      class="flex min-w-0 items-center justify-center lg2:min-w-[190px] xl:min-w-[210px]"
    >
      <div
        class="text-[2.75rem] font-normal leading-[3.25rem] text-white md:text-[3.25rem] md:leading-[4rem] lg2:text-[4rem] lg2:leading-[4.75rem] xl:text-[5rem] xl:leading-[6rem]"
        aria-hidden="true"
      >
        @if (isLoading) {
          <div
            class="h-12 w-16 animate-pulse rounded bg-white/20 lg2:h-16 lg2:w-20 xl:h-20 xl:w-24"
            role="status"
            aria-label="Loading non-proactive ticket count"
          ></div>
        } @else {
          {{ ticketTypeCount()?.nonProactive || 0 }}
        }
      </div>
      <div
        class="min-w-0 pl-2 pt-1 text-[10px] font-bold uppercase leading-3 text-white/60 lg2:pl-3 lg2:pt-2 lg2:text-sm lg2:leading-5 xl:pl-4 xl:text-base xl:leading-6"
      >
        Non-Proactive
        <span
          class="flex whitespace-nowrap text-xl font-normal normal-case leading-7 text-white/80 md:text-2xl md:leading-8 lg2:text-[32px] lg2:leading-[40px] xl:text-[40px] xl:leading-[48px]"
          aria-hidden="true"
        >
          Ticket{{ ticketTypeCount()?.nonProactive === 1 ? '' : 's' }}
        </span>
      </div>
    </div>
    <div
      class="mt-1 hidden space-y-0.5 text-center font-lato md:block md:text-[11px] lg2:text-xs xl:text-sm"
    >
      <div class="text-white/60">
        Avg. NOC Pickup Time:
        <span class="font-bold text-white/90">{{
          nonProactiveAverageTimeToFirstTouch()
        }}</span>
      </div>
      <div class="text-white/60">
        Avg. NOC Repair Time:
        <span class="font-bold text-white/90">{{
          nonProactiveAverageTimeToRepair()
        }}</span>
      </div>
    </div>
  </div>
</section>
